import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {PresenterProps, withPresenter} from '../../../../../Support/with_presenter';
import {RsvpResponseCellPresenter} from './RsvpResponseCellPresenter';
import {CalendarEvent, RsvpResponse} from '../../../../../Models/CalendarEvent';
import {classNames} from '../../../../Support/classNames';

interface OwnProps {
    userId: number;
    calendarEvent: CalendarEvent;
    interactive?: boolean;
    tiny?: boolean;
}

const RsvpResponseCellComponent: FunctionComponent<OwnProps & PresenterProps<RsvpResponseCellPresenter>> = observer(
    ({interactive, tiny, presenter}) => {
        const classes = classNames('rsvp__response', {
            'rsvp__response--tiny': tiny === true,
        });

        switch (presenter.response) {
            case RsvpResponse.Yes:
                if (interactive) {
                    return (
                        <button
                            className={classNames(classes, 'rsvp__response--yes')}
                            onClick={() => presenter.toggle()}
                        >
                            <i className="bi bi-check-lg" />
                        </button>
                    );
                }
                return (
                    <div className={classNames(classes, 'rsvp__response--yes')}>
                        <i className="bi bi-check-lg" />
                    </div>
                );
            case RsvpResponse.Maybe:
                if (interactive) {
                    return (
                        <button
                            className={classNames(classes, 'rsvp__response--maybe')}
                            onClick={() => presenter.toggle()}
                        >
                            <i className="bi bi-question-lg" />
                        </button>
                    );
                }
                return (
                    <div className={classNames(classes, 'rsvp__response--maybe')}>
                        <i className="bi bi-question-lg" />
                    </div>
                );
            case RsvpResponse.No:
                if (interactive) {
                    return (
                        <button
                            className={classNames(classes, 'rsvp__response--no')}
                            onClick={() => presenter.toggle()}
                        >
                            <i className="bi bi-dash-lg" />
                        </button>
                    );
                }
                return (
                    <div className={classNames(classes, 'rsvp__response--no')}>
                        <i className="bi bi-dash-lg" />
                    </div>
                );
            case RsvpResponse.Unknown:
                if (interactive) {
                    return (
                        <button
                            className={classNames(classes, 'rsvp__response--unknown')}
                            onClick={() => presenter.toggle()}
                        >
                            <i className="bi bi-question-lg" />
                        </button>
                    );
                }
                return (
                    <div className={classNames(classes, 'rsvp__response--unknown')}>
                        <i className="bi bi-question-lg" />
                    </div>
                );
        }
    },
);

export const RsvpResponseCell = withPresenter<RsvpResponseCellPresenter, OwnProps>(
    (props, component) => new RsvpResponseCellPresenter(props.userId, props.calendarEvent, component.rsvp),
    RsvpResponseCellComponent,
);
